/* Erros que podem ser retornados pela Clisitef */

const CONFIGURE = {
    '1': 'Endereço IP inválido ou não resolvido',
    '2': 'Código da loja inválido',
    '3': 'Código de terminal inválido',
    '6': 'Erro na inicialização do Tcp/Ip',
    '7': 'Falta de memória',
    '8': 'Não encontrou a CliSiTef ou ela está com problemas',
    '9': 'Configuração de servidores SiTef foi excedida.',
    '10': 'Erro de acesso na pasta CliSiTef (possível falta de permissão para escrita)',
    '11': 'Dados inválidos passados pela automação.',
    '12': 'Modo seguro não ativo (possível falta de configuração no servidor SiTef do arquivo .cha).',
    '13': 'Caminho DLL inválido (o caminho completo das bibliotecas está muito grande).',

    /* outro valor positivo negada pelo autorizador. */
    /* Por algum motivo a rota configure esta retonando os mesmos valores de erro da transaction por isso esse bloco foi duplicado */
    '-1': '-1 Módulo não inicializado. O PDV tentou chamar alguma rotina sem antes executar a função configura.',
    '-2': '-2 Operação cancelada pelo operador.',
    '-3': '-3 O parâmetro função / modalidade é inexistente/inválido.',
    '-4': '-4 Falta de memória no PDV.',
    '-5': '-5 Sem comunicação com o SiTef.',
    '-6': '-6 Operação cancelada pelo usuário (no pinpad).',
    '-7': '-7 Reservado',
    '-8': '-8 A CliSiTef não possui a implementação da função necessária, provavelmente está desatualizada (a CliSiTefI é mais recente).',
    '-9': '-9 A automação chamou a rotina ContinuaFuncaoSiTefInterativo sem antes iniciar uma função iterativa.',
    '-10': '-10 Algum parâmetro obrigatório não foi passado pela automação comercial.',
    '-12': '-12 Erro na execução da rotina iterativa. Provavelmente o processo iterativo anterior não foi executado até o final (enquanto o retorno for igual a 10000).',
    '-13': '-13 Documento fiscal não encontrado nos registros da CliSiTef. Retornado em funções de consulta tais como ObtemQuantidadeTransaçõesPendentes.',
    '-15': '-15 Operação cancelada pela automação comercial.',
    '-20': '-20 Parâmetro inválido passado para a função.',
    '-21': '-21 Utilizada uma palavra proibida, por exemplo SENHA, para coletar dados em aberto no pinpad. Por exemplo na função ObtemDadoPinpadDiretoEx.',
    '-25': '-25 Erro no Correspondente Bancário: Deve realizar sangria.',
    '-30': '-30 Erro de acesso ao arquivo. Certifique-se que o usuário que roda a aplicação tem direitos de leitura/escrita.',
    '-40': '-40 Transação negada pelo servidor SiTef.',
    '-41': '-41 Dados inválidos.',
    '-42': '-42 Reservado',
    '-43': '-43 Problema na execução de alguma das rotinas no pinpad.',
    '-50': '-50 Transação não segura.',
    '-100': '-100 Erro interno do módulo.',
    'perifericos': 'Falha de comunicação com o periféricos.'
}

const TRANSACTION = {
    /* outro valor positivo negada pelo autorizador. */
    '-1': '-1 Módulo não inicializado. O PDV tentou chamar alguma rotina sem antes executar a função configura.',
    '-2': '-2 Operação cancelada pelo operador.',
    '-3': '-3 O parâmetro função / modalidade é inexistente/inválido.',
    '-4': '-4 Falta de memória no PDV.',
    '-5': '-5 Sem comunicação com o SiTef.',
    '-6': '-6 Operação cancelada pelo usuário (no pinpad).',
    '-7': '-7 Reservado',
    '-8': '-8 A CliSiTef não possui a implementação da função necessária, provavelmente está desatualizada (a CliSiTefI é mais recente).',
    '-9': '-9 A automação chamou a rotina ContinuaFuncaoSiTefInterativo sem antes iniciar uma função iterativa.',
    '-10': '-10 Algum parâmetro obrigatório não foi passado pela automação comercial.',
    '-12': '-12 Erro na execução da rotina iterativa. Provavelmente o processo iterativo anterior não foi executado até o final (enquanto o retorno for igual a 10000).',
    '-13': '-13 Documento fiscal não encontrado nos registros da CliSiTef. Retornado em funções de consulta tais como ObtemQuantidadeTransaçõesPendentes.',
    '-15': '-15 Operação cancelada pela automação comercial.',
    '-20': '-20 Parâmetro inválido passado para a função.',
    '-21': '-21 Utilizada uma palavra proibida, por exemplo SENHA, para coletar dados em aberto no pinpad. Por exemplo na função ObtemDadoPinpadDiretoEx.',
    '-25': '-25 Erro no Correspondente Bancário: Deve realizar sangria.',
    '-30': '-30 Erro de acesso ao arquivo. Certifique-se que o usuário que roda a aplicação tem direitos de leitura/escrita.',
    '-40': '-40 Transação negada pelo servidor SiTef.',
    '-41': '-41 Dados inválidos.',
    '-42': '-42 Reservado',
    '-43': '-43 Problema na execução de alguma das rotinas no pinpad.',
    '-50': '-50 Transação não segura.',
    '-100': '-100 Erro interno do módulo.',
    'perifericos': 'Falha de comunicação com o periféricos.'
}

export default {
    getErrorConfigure: function (errorCode) {
        if (!errorCode) {
            return 'Erro não identificado'
        }
        try {
            if (errorCode < -10000) return `Erro ${errorCode}: <br> Não identificado`
            errorCode = errorCode.toString()
            if (CONFIGURE[errorCode]) return `Erro ${errorCode} SITEF: <br> ${CONFIGURE[errorCode]}`
            return `Erro SITEF ${errorCode}: <br> Não identificado`
        } catch (error) {
            console.log(error)
            return `Erro não identificado`
        }
    },
    getErrorTransaction: function (errorCode) {
        if (!errorCode) {
            return 'Erro não identificado'
        }
        if (errorCode < -10000) return `Erro ${errorCode}: <br> Não identificado`
        if (errorCode === 0 || errorCode === 1000) return ''
        if (errorCode > 0) return `Erro ${errorCode} SITEF: <br> Negado pelo autorizador`
        try {
            errorCode = errorCode.toString()
            if (errorCode === '-2' || errorCode === '-6') return TRANSACTION[errorCode]
            if (TRANSACTION[errorCode]) return `Erro ${errorCode} SITEF: <br> ${TRANSACTION[errorCode]}`
            return `Erro SITEF ${errorCode}: <br> Não identificado`
        } catch (error) {
            console.log(error)
            return `Erro não identificado`
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/tef/TefErrors.js